const images = [
  {
    src: "https://images.pexels.com/photos/8063795/pexels-photo-8063795.jpeg",
    alt: "Handmade ceramic pottery and craft pieces in a minimalist style.",
    credit: "ROMAN ODINTSOV / Pexels",
  },
  {
    src: "https://images.pexels.com/photos/6963814/pexels-photo-6963814.jpeg",
    alt: "Shelves with cups, bowls, teapot, and pitcher.",
    credit: "Cup of Couple / Pexels",
  },
  {
    src: "https://images.pexels.com/photos/5741875/pexels-photo-5741875.jpeg",
    alt: "Minimalist arrangement of ceramic vases and natural elements.",
    credit: "Thom Bradley / Pexels",
  },
  {
    src: "https://images.pexels.com/photos/15440832/pexels-photo-15440832.jpeg",
    alt: "Handcrafted pottery on wooden shelves in a studio setting.",
    credit: "Oleg Prachuk / Pexels",
  },
  {
    src: "https://images.pexels.com/photos/28868030/pexels-photo-28868030.jpeg",
    alt: "Ceramic bowl and plate on a wooden stool.",
    credit: "Jonathan Borba / Pexels",
  },
  {
    src: "https://images.pexels.com/photos/19217225/pexels-photo-19217225.jpeg",
    alt: "Pottery vases in an art gallery.",
    credit: "Pavel Morillo / Pexels",
  },
];

export function Gallery() {
  return (
    <div className="max-w-6xl mx-auto container-px py-14">
      <header className="mb-10">
        <h1 className="text-3xl md:text-4xl display">Gallery</h1>
        <p className="text-foreground/70 mt-3 max-w-2xl">
          Objects in warm, tactile finishes. Each piece is hand-formed in Bangkok with a
          Scandinavian sensibility.
        </p>
      </header>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {images.map((img) => (
          <figure
            key={img.src}
            className="group overflow-hidden rounded-xl border border-border bg-card"
          >
            <img
              src={`${img.src}?auto=compress&cs=tinysrgb&w=1200`}
              alt={img.alt}
              className="aspect-[4/3] w-full object-cover transition-transform duration-500 group-hover:scale-105"
              loading="lazy"
            />
            <figcaption className="p-4 text-xs text-foreground/70">{img.credit}</figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
}
